import React, { Component } from 'react'

import CallBox from '../CallBox'
import SocialLinks from '../SocialLinks'

class SimpleFooter extends Component {
    logo() {
        const { info, logoInverted } = this.props

        return logoInverted ? info.logo_invert : info.logo
    }

    render() {
        const { info, css } = this.props

        return (
            <div className="container">
                <div className={`row ${css} light_links top-align sm-center`} style={{ fontSize: '1.4em' }}>
                    <div className="col-md-4">
                        <div className="pull-left"><span><img src={this.logo()} className="img-responsive" style={{ maxHeight: 60 }} alt="" /><br /><br /></span></div>
                    </div>
                    <div className="col-md-4 light_links">
                        <CallBox info={info} />
                    </div>
                    <div className="col-md-4 text-right light_links sm-center">
                        <SocialLinks css="light_links" />
                    </div>
                </div>
            </div>
        )
    }
}

export { SimpleFooter }


// WEBPACK FOOTER //
// ./src/components/sections/SimpleFooter.js